import { AppThunk } from '@lib/state/types';
import {
    youtubeParser,
    youtubeParseChannel,
    mapYoutubeListVideoResults,
    mapYoutubeListChannelResults,
} from '@lib/helpers/utils';
import { APP_CONFIG } from '@lib/constants';
import {
    FetchYoutubeVideoPayload,
    YoutubeVideoPayload,
    FetchYoutubeVideoResult,
} from './types';
import { YoutubeActions } from '../_actions';

/**
 * fetch youtube video
 *
 * @returns {AppThunk<Promise<void>>}
 */
export const fetchYoutubeVideo =
    ({
        videoUrl,
        key,
        pageToken,
    }: FetchYoutubeVideoPayload): AppThunk<Promise<FetchYoutubeVideoResult>> =>
    async (
        _dispatch,
        _getState,
        container,
    ): Promise<FetchYoutubeVideoResult> => {
        const payload: YoutubeVideoPayload = {
            id: videoUrl,
            channelId: videoUrl,
            part: 'snippet',
            maxResults: 20,
            key: key,
            type: 'video',
            pageToken,
        };
        const options = {
            baseURL: APP_CONFIG.YOUTUBE.SEARCH_URL,
        };
        const res = await container.cradle.youtubeService.getYoutubeVideo(
            payload,
            options,
        );
        if (res.data?.nextPageToken) {
            _dispatch(
                YoutubeActions.setNextPageTokenVideo(res.data?.nextPageToken),
            );
        } else {
            _dispatch(YoutubeActions.setNextPageTokenVideo(undefined));
        }

        return {
            videos: mapYoutubeListVideoResults(res.data.items),
            nextPageToken: res.data?.nextPageToken,
        };
    };

export const fetchYoutubeChannel =
    (
        data: FetchYoutubeVideoPayload,
    ): AppThunk<Promise<FetchYoutubeVideoResult>> =>
    async (
        _dispatch,
        _getState,
        container,
    ): Promise<FetchYoutubeVideoResult> => {
        const id = youtubeParser(data.videoUrl);
        const channelId = youtubeParseChannel(data.videoUrl);
        const payload: YoutubeVideoPayload = {
            id,
            channelId,
            part: 'snippet',
            maxResults: 4,
            key: data.key,
            type: 'channel',
            q: !id && !channelId ? data.videoUrl : undefined,
            pageToken: data.pageToken,
        };

        const options = {
            baseURL: id
                ? APP_CONFIG.YOUTUBE.VIDEOS_URL
                : APP_CONFIG.YOUTUBE.SEARCH_URL,
        };

        const res = await container.cradle.youtubeService.getYoutubeVideo(
            payload,
            options,
        );

        return {
            videos: mapYoutubeListChannelResults(res.data.items),
            nextPageToken: res.data?.nextPageToken,
        };
    };

const YoutubeThunks = {
    fetchYoutubeVideo,
    fetchYoutubeChannel,
};

export default YoutubeThunks;
